import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { Item, SnackbarService } from '@siat-fe/shared';
import { pipe, switchMap, tap } from 'rxjs';
import { TipologicheService } from './select-tipologica-field.service';

/**
 * State type.
 */
type ListaTipologicheState = {
  listaTipologicaItemResponse: Item[];
  pureItems: unknown[];
  isLoading: boolean;
  hasError: boolean;
};

/**
 * Initial state.
 */
const initialState: ListaTipologicheState = {
  listaTipologicaItemResponse: [],
  pureItems: [],
  isLoading: false,
  hasError: false,
};

export const ListaTipologicheStore = signalStore(
  withState<ListaTipologicheState>(initialState),
  withMethods((store, snackbarService = inject(SnackbarService)) => {
    /**
     * Set error.
     */
    const _setError = (hasError: boolean, _message?: string): void => {
      patchState(store, { hasError, isLoading: false });
    };
    /**
     * Set success.
     */
    const _setSuccess = (message: string): void => {
      snackbarService.showSuccessSnackbar(message);
    };

    const _setListItem = (listaTipologicaItemResponse: object[]): void => {
      patchState(store, {
        pureItems: listaTipologicaItemResponse,
        listaTipologicaItemResponse: listaTipologicaItemResponse.map(
          tipologica => ({
            id: tipologica['id'],
            name:
              tipologica['nome'] ||
              tipologica['denominazione'] ||
              tipologica['valore'],
            icon: tipologica['ambito'] === true ? 'home' : null,
            ...tipologica,
          })
        ),
        hasError: false,
        isLoading: false,
      });
    };
    return {
      _setError,
      _setSuccess,
      _setListItem,
    };
  }),
  withMethods((store, tipologicheService = inject(TipologicheService)) => {
    const fetchGetAllTipologicaItem = rxMethod<[string, boolean]>(
      pipe(
        tap(() => {
          patchState(store, { isLoading: true });
        }),
        switchMap(([tipologica, withFindAll]) =>
          tipologicheService
            .fetchGetAllTipologicaItem(tipologica, withFindAll)
            .pipe(
              tapResponse({
                next: (response: never[]) => store._setListItem(response),
                error: () => store._setError(true),
                finalize: () => {
                  patchState(store, { isLoading: false });
                },
              })
            )
        )
      )
    );

    return {
      fetchGetAllTipologicaItem,
    };
  }),
  withMethods(store => ({
    /**
     * Reload update list.
     */
    _reloadListItem(message: string): void {
      store._setSuccess(message);
    },
  }))
);
